module.exports = __webpack_public_path__ + "img/book-vertical.d5fb0dca.svg";